import { RemixiconComponentType } from '@remixicon/react';

export const IconFlag: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path d="M22.814 0H2v22h2v-7h18.814l-4.33-7.5 4.33-7.5zM4 13V2h15.35l-3.176 5.5 3.175 5.5H4z" />
  </svg>
);
